import { useState } from 'react';
import { IconButton } from '@chakra-ui/react';
import { LuPhone } from 'react-icons/lu';
import { Tooltip } from '@components/ui/tooltip';
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2';
import api from '@services/api';
import useCheckMyDispositions from '@hooks/useCheckMyDispositions';

import type { PendingExecutionType } from '../types';
import ConfirmStartExecutionDialog from './ConfirmStartExecutionDialog';
import PendingCampaignExecutionDialog from './PendingCampaignExecutionDialog';

type Props = {
  executionId: string,
};

const StartExecutionButton = ({ executionId }: Props) => {
  const [showConfirmStartExecutionDialog, setShowConfirmStartExecutionDialog] = useState(false);
  const [showPendingExecutionDialog, setShowPendingExecutionDialog] = useState(false);
  const [pendingExecutionDetails, setPendingExecutionDetails] = useState<PendingExecutionType | null>(null);
  const [checkingExecutions, setCheckingExecutions] = useState(false);

  const { checkMyDispositions, loading: checkingMyDispositions } = useCheckMyDispositions();

  const checkPendingExecutions = async () => {
    setCheckingExecutions(true);
    try {
      const response = await api.get(`/campaign_execution/pending/${executionId}`);
      setPendingExecutionDetails(response.data);
      if (response.data.open_dispositions > 0) {
        setShowPendingExecutionDialog(true);
      } else {
        setShowConfirmStartExecutionDialog(true);
      }
    } finally {
      setCheckingExecutions(false);
    }
  };

  return (
    <>
      <Tooltip content="Ver meus atendimentos" showArrow>
        <IconButton
          variant="ghost"
          color="argos.fg"
          onClick={() => checkMyDispositions(executionId)}
          loading={checkingMyDispositions}
        >
          <HiOutlineClipboardDocumentList size={24} />
        </IconButton>
      </Tooltip>
      
      <Tooltip content="Iniciar atendimento" showArrow>
        <IconButton
          variant="ghost"
          color="argos.fg"
          onClick={checkPendingExecutions}
          loading={checkingExecutions}
        >
          <LuPhone size={24} />
        </IconButton>
      </Tooltip>

      {showConfirmStartExecutionDialog && (
        <ConfirmStartExecutionDialog executionId={executionId} handleClose={() => setShowConfirmStartExecutionDialog(false)} />
      )}

      {showPendingExecutionDialog && pendingExecutionDetails && (
        <PendingCampaignExecutionDialog
          pendingExecutionDetails={pendingExecutionDetails}
          handleClose={() => setShowPendingExecutionDialog(false)}
          onStartExecutionClick={() => setShowConfirmStartExecutionDialog(true)}
          onCheckPendingExecutionsClick={() => checkMyDispositions(executionId)}
        />
      )}
    </>
  );
};

export default StartExecutionButton;
